import { NextLink } from 'components/blocks/NextLink';
import { useRef } from 'react';
import { SanitizeMode, useSanitizedHtmlProps } from 'util/sanitized';
import { useVisibilityWindow } from 'util/useVisibilityWindow';
import { IResortPageInfo, IResortPathInfo } from 'api/resort/types';
import { useQueryWithInitialValue } from 'util/useQueryWithInitialValue';
import { fetchResortShortInfo } from 'api/resort/static';
import { Routes } from 'routes';
import { useBrandfolderOptimizedImage } from 'util/useBrandfolderOptimizedImage';
import styles from './styles.module.scss';

export const Resort = ({
  resort,
  isFresh,
}: {
  resort: IResortPathInfo,
  isFresh: boolean,
}) => {
  const { current: curResort } = useQueryWithInitialValue(['resort-fetchResortShortInfo', resort.uuid],
    async () => fetchResortShortInfo(resort.uuid),
    {} as IResortPageInfo);

  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useVisibilityWindow(ref, true);
  const title = useSanitizedHtmlProps(curResort.title || '', SanitizeMode.TextOnly);
  const image = (isFresh && isVisible) ? (curResort.image) : '';
  const optimizedImage = useBrandfolderOptimizedImage(image);
  const style = optimizedImage ? { backgroundImage: `url(${optimizedImage})`, backgroundSize: 'cover' } : { };

  return (
    <div className={styles.box} ref={ref}>
      <NextLink href={Routes.resortSnowReport(resort)} data-click-id="related">
        <figure style={style} tabIndex={-1} />
        <div className={styles.footer}>
          {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
          <span {...title} className={styles.title} />
        </div>
      </NextLink>
    </div>
  );
};
